import React from "react";
import { Button, Modal } from "react-bootstrap";
const ApproveSessionModal = (props) => {
  return (
    <React.Fragment>
      <Modal
        show={props.show}
        onHide={() => {
          props.handleClose();
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Approve Session: {props.session.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure, you want to approve this session?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              props.handleClose();
            }}
          >
            Close
          </Button>
          <Button
            variant="primary"
            style={{
              position: "relative",
            }}
            onClick={() => {
              props.handleApprove(true);
              props.handleClose();
            }}
          >
            {" "}
            Approve
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};
export default ApproveSessionModal;
